import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';

export const CMS_CONFIG_SCURRI = 'scurri_config';

export interface IICmsConfigScurriDataContent extends IConfigData {
    enabledEstimatedDelivery?: boolean;
}
export interface IICmsConfigScurriData extends ICmsConfig<IICmsConfigScurriDataContent> {}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_SCURRI,
    name: 'Scurri configuration',
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'enabledEstimatedDelivery',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Enable estimated delivery'
        }
    ]
});
